<label [for]="id">{{label}}</label>

<input
    [id]="id"
    [type]="type"
    [disabled]="disabled"
    [formControl]="formGetter"
    class="form-control"
    [ngClass]="{ 'is-invalid': submitted && formGetter[fControlName].errors }"
/>
